import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const ADD_TEACHER_TO_CLASS = gql`
  mutation AddTeacherToClass($schoolClassId: Int!, $teacherEmail: String!) {
    addSchoolClassTeacher(schoolClassID: $schoolClassId, email: $teacherEmail) {
      type,
      message
    }
  }
`;
